import { defineStore, getActivePinia } from 'pinia'
import * as API from '@/api/rx-factory'
import * as ENDPOINTS from '@/api/endpoints'
import router from '@/router'
import { useToast } from 'vue-toastification'
import ToastMessage from '@/components/shared/toast_message.vue'
import static_vars from '@/staticVars'
// const Buffer = require('buffer/').Buffer
import { Buffer } from "buffer";
const qs = require('qs');
const toast = useToast();
interface tostType {
  [key: string]: string;
}
const tostTypeError: tostType = { type: "error" };
const tostTypeSuccess: tostType = { type: "success" };
const successHandler = (message, redirect) => {
  toast(message, {
    timeout: 4000
  })
  if (redirect) {
    if (redirect && redirect == 'back') {
      router.back()
    } else {
      router.push(`/${redirect}`)
    }
  }
}


export const useMainStore = defineStore('main', {
  persist: {
    key: 'storekey',
    storage: window.localStorage,
    paths: ['user','customerDetail','countryList','brokersList','brokerStatusList','brokerInfo','brokerQuestionsList','stabilityQuestionsList','sumSubDetail','brokerSettingsList','brokerPlatformList','brokerSymbolPattern','userAccoutDetail','linkBrokerID','flavorData','failTest','otherBrokerFullList','accountConnectSocket','socketError'],
  },
  state: () => ({
    loading: false,
    singleLoading : false,
    loader : false,
    user : {},
    error : {type : '' ,msg : ''},
    customerDetail : {},
    countryList : {},
    brokersList : {},
    brokerCurrencyList : {},
    brokerServerList : {},
    brokerSymbolPattern : [],
    brokerStatusList : {},
    StepsJson : {'PersonalInformationPartA' : '/personalInfo-step1','FinancialDetails':'/financial-detials','Questionnaire':'/questionnaires','Declaration' : '/declaration','POR':'/upload-por','SumSub' : '/sumsub','AccountPreferences' : '/account-preferences', 'AddFunds' : '/add-funds','SuitabilityTest' : '/sutaibility'},
    brokerInfo : {},
    brokerQuestionsList : {},
    stabilityQuestionsList : {},
    sumSubDetail : {},
    brokerSettingsList : {},
    brokerPlatformList : [],
    getBrokerTradingAccList : [],
    // subscriptionPlans: [],
    // subscriptionCards: [],
    // subscriptionSelected: {},
    // subscriptionSelectedPayload: {},
    userAccoutDetail : {},
    linkBrokerID : null,
    linkBrokerStatus : false,
    flavorData : {},
    acoountconnecting : false,
    isGiftPopup: false,
    questionariesStatus : {},
    failTest : {},
    isLogin : false,
    priorityPayment: '',
    otherBrokerFullList: {},
    accountConnectSocket: {},
    socketError: {},
  }),
  getters: {
    getToken(){
      static_vars.getCookie('zulutoken')
    }
  },
  actions: {

    //Login
    login(params = {}, loader = false,token,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        const inputjson = JSON.parse(JSON.stringify(params));
        if(params['tokenType']){
          delete params['tokenType']
        }
        params['demoAccountTriggered'] = false;
        const data = qs.stringify(params)
        API.post(ENDPOINTS.EP_USER_LOGIN, data,token).then(response => {
          this.loading = false
          if (response.access_token) {
            // static_vars.setCookie('zulutoken',response.access_token,'100d')
            //  static_vars.setCookie('zulurefreshToken',response.refresh_token,'100d')
            if(Object.keys(response).length && response.access_token){
                localStorage.setItem('zulutoken', response.access_token);
                if(response.refresh_token){
                    localStorage.setItem('zulurefreshToken', response.refresh_token);
                }
            }
            this.user = response
            if(inputjson['tokenType']){
              _that.callCustomerDetail({},false, _that)
              if(inputjson['tokenType'] == 'EMAIL'){
                router.replace('/get-otp')
              }else{
                router.replace('/personal-details')
              }
            }else{
              router.replace('/personal-details')
            }
            //console.log('===>',static_vars.getCookie('zulutoken'))
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    refreshToken(params = {}, loader = false,token) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        const inputjson = JSON.parse(JSON.stringify(params));
        if(params['tokenType']){
          delete params['tokenType']
        }
        const data = qs.stringify(params)
        API.post(ENDPOINTS.EP_USER_LOGIN, data,token).then(response => {
          this.loading = false
          if (response.access_token) {
            // static_vars.setCookie('zulutoken',response.access_token,'100d')
            //  static_vars.setCookie('zulurefreshToken',response.refresh_token,'100d')
             localStorage.setItem('zulutoken', response.access_token);
            localStorage.setItem('zulurefreshToken', response.refresh_token);
            this.user = response
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },

    //register
    register(params = {}, loader = false,_that,type) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
         const data = JSON.stringify(params)
        API.post(ENDPOINTS.EP_REGISTRATION, data).then(response => {
          this.loading = false
          if(type && type == 'Google'){
              _that.CretioGoogleFunc()
             _that.loginWithGoogle(params['token'])
          }else{
            //_that.CretioFunc()
           try{
              (window as any).gtag('event', 'Gen_Lead_2.0');
          }catch(ex){console.log(ex)}
            _that.loginMannual(params['tokenType'])
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          try{
              (window as any).gtag('event', 'Gen_Lead_2.0');
          }catch(ex){console.log(ex)}
          reject(error)
        })
      });
    },
    getFlavourData(params = {}, loader = false) {
      if (loader) {
        this.loading = true;
      }
      return new Promise((resolve, reject) => {
        const ep = (this.user.access_token || localStorage.getItem("zulutoken")) ? ENDPOINTS.EP_GET_FLAVOR_LIST : ENDPOINTS.EP_GET_LOGOUT_FLAVOR_LIST
        API.get(ep)
          .then((response) => {
            this.loading = false;
            this.flavorData = response;
            if(this.user.access_token && Object.keys(response).length && response?.isEu && this.liveAccounts()){
              this.getQuestioanriesStatus({},false)
            }
            resolve(response);
          })
          .catch((error) => {
            this.loading = false;
            reject(error);
          });
      });
    },
    liveAccounts(){
      if(Object.keys(this.userAccoutDetail).length && this.userAccoutDetail?.accounts){
        const data = Object.values(this.userAccoutDetail.accounts).filter( (i:any)=> !i.demo);
        if(data.length){
          return true
        }else{
          return false
        }
      }else{
        return false
      }
    },
    verifyOTP(params = {}, loader = false,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.singleLoading = true
        }
        const inputjson = JSON.parse(JSON.stringify(params));
        delete params['page']
        API.put(ENDPOINTS.EP_VERIFY_OTP, params).then(response => {
          this.singleLoading = false
          if(response === true){
            _that.CretioFunc();
            if(inputjson['page'] && inputjson['page'] == 'PersonalDetail'){
              _that.showEmailCode = false
              _that.form.emailcode = ''
            }
            // else{
            //   router.replace('/complete-registration')
            // }
          }
          resolve(response)
        }).catch(error => {
          this.singleLoading = false
          reject(error)
        })
      });
    },
    resendOTP(params = {}, loader = false,token) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.singleLoading = true
        }
        API.post(ENDPOINTS.EP_RESEND_OTP, params,token).then(response => {
          this.singleLoading = false
          resolve(response)
        }).catch(error => {
          this.singleLoading = false
          reject(error)
        })
      });
    },

    //Generate reset password link
    forgotPassword(params = {}, loader = false) {
      if (loader) {
        this.loading = true
      }
      API.put(ENDPOINTS.EP_USER_FORGOT_PASSWORD, params).then(response => {
        this.loading = false
         toast("Reset link sent to your registered email. Please check", tostTypeSuccess);
      }).catch(error => {
        this.loading = false
      })
    },

    callCustomerDetail(params = {}, loader = false,_that,type) {
      // console.log("this.$route", this.$route);

       return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = false
        }
        API.get(ENDPOINTS.EP_GET_CUSTOMER_DETAILS).then(response => {
          this.loading = false
          this.customerDetail = response;


          // check email verification and personal details, if not redirect to otp/ personal details page
          if (this.customerDetail.emailVerified == false ) {
            if( _that.$route.name != 'Get_OTP' ){
              window.open(`${static_vars.domainURL}register/get-otp`,'_self')
            }
          }       
          else if (this.customerDetail.phoneNumber == ''|| this.customerDetail.countryIsoCodeA3 ==''){
            if( _that.$route.name != 'personal_details'){
              window.open(`${static_vars.domainURL}register/personal-details`,'_self')
            }
          }
          // else if(this.customerDetail.profileName  =='' || !this.customerDetail.profileName){
          //     if(_that.$route.name != 'Image'){
          //       window.open(`${static_vars.domainURL}register/upload-image`,'_self')
          //     }
          // }

          if(type && type == 'Email'){
            _that.getEmailCode()
          }else if(type && type == 'Phone'){
            _that.SendSMS()
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
         reject(error)
        })
      })
    },

    
    //Verify reset password link
    resetPassword(params = {}, loader = false) {
      if (loader) {
        this.loading = true
      }
      API.put(ENDPOINTS.EP_RESET_PASSWORD_FROM_HASH, params).then(response => {
        this.loading = false
         toast("Success! Please login using your new password", tostTypeSuccess);
         window.location.replace(`${static_vars.domainURL}login`)
      }).catch(error => {
        this.loading = false
      })
    },
    callCountryList(params = {}, loader = false) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        API.get(ENDPOINTS.EP_GET_COUNTRY_LIST).then(response => {
          this.loading = false
          this.countryList = response
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      })
    },
    callUpdateProfileInfo(params = {}, loader = false,_that,type) {
       return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = false
        }
        API.put(ENDPOINTS.EP_GET_CUSTOMER_DETAILS, params).then(response => {
          // if(!_that.form.file.name){
          //    this.loading = false
          //   _that.getUserDetail()
          //   if(this.customerDetail.emailVerified && this.customerDetail.phoneVerified){
          //     router.replace('/upload-image')//trading-account
          //   }
          // }else{
          //    this.loading = true
          // }
          _that.getUserDetail()
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      })
    },
    userNamePUT(params = {}, loader = false,_that) {
      return new Promise((resolve, reject) => {
        if (loader) { this.loader = true; }
        API.put(ENDPOINTS.EP_PUT_USER_NAME, params)
          .then((response) => {
           this.loader = false;
           _that.getUserDetail()
            resolve(response);
          })
          .catch((error) => {
           this.loader = false;
            reject(error);
          });
      });
    },
    sendOtpMobile(params = {}, loader = false) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loader = true
        }
        API.post(ENDPOINTS.EP_SEND_SMS_MOBILE, params).then(response => {
          this.loader = false
          resolve(response)
        }).catch(error => {
          this.loader = false
          reject(error)
        })
      });
    },
     verifyMobileOTP(params = {}, loader = false,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loader = true
        }
        API.put(ENDPOINTS.EP_VERIFY_MOBILE_OTP, params).then(response => {
          this.loader = false
          resolve(response)
        }).catch(error => {
          this.loader = false
          reject(error)
        })
      });
    },
    uploadUserImage(params = {}, loader = false) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        API.post(ENDPOINTS.EP_UPLOAD_USER_IMAGE,params).then(response => {
          this.loading = false
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    getBrokersList(params = {}, loader = false) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        API.get(ENDPOINTS.EP_GET_BROKERS_LIST).then(response => {
          this.loading = false
          this.brokersList = response
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    getBrokerListwithPlatforms(params = {}, loader = false) {
      if (loader) {
        this.loading = true
      }
      API.get(ENDPOINTS.EP_GET_BROKER_PLATFORM_LIST).then(response => {
        this.loading = false
        this.brokerPlatformList = response
      }).catch(error => {
        this.loading = false
      })
    },
    getBrokerCuurenciesList(params = {}, loader = false,ID) {
      if (loader) {
        this.loading = true
      }
      let ep = ENDPOINTS.EP_GET_BROKER_CURRENCY_LIST
      ep = ep.replace("{{ID}}",ID)
      API.get(ep).then(response => {
        this.loading = false
        this.brokerCurrencyList = response
      }).catch(error => {
        this.loading = false
      })
    },
    getBrokerServerList(params = {}, loader = false,ID) {
      if (loader) {
        this.loading = true
      }
      let ep = ENDPOINTS.EP_GET_BROKER_SERVER_LIST
      ep = ep.replace("{{ID}}",ID)
      API.get(ep).then(response => {
        this.loading = false
        this.brokerServerList = response
      }).catch(error => {
        this.loading = false
      })
    },
    getBrokerSymbolPattern(params = {}, loader = false,ID) {
      if (loader) {
        this.loading = true
      }
      let ep = ENDPOINTS.EP_GET_BROKER_SYMBOL_PATTERN
      ep = ep.replace("{{ID}}",ID)
      API.get(ep).then(response => {
        this.loading = false
        this.brokerSymbolPattern = response
      }).catch(error => {
        this.loading = false
      })
    },
    connectBroker(params = {}, loader = false,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        API.post(ENDPOINTS.EP_CONNECT_EXISTING_BROKER, params).then(response => {
          this.loading = false
          // toast("Account Connected Successfully", tostTypeSuccess);
          // if(Object.keys(response).length){
          //   _that.userAccountsList()
          // }
          //this.linkBrokerStatus = true
          // try{
          //   (window as any).gtag('event', 'Live_ac_verified');
          // }catch(ex){console.log(ex);}
          resolve(response)
        }).catch(error => {
          this.loading = false
           //this.linkBrokerStatus = false
          router.replace('/broker-account')
          toast("Wrong Credentials.Please Check your credentials", tostTypeError);
          reject(error)
        })
      });
    },
    getUserAccountsList(params = {}, loader = false) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        
        API.get(ENDPOINTS.EP_USER_DETAIL_WITH_ACCOUNTS).then(response => {
          this.loading = false
          this.userAccoutDetail = response
          if(this.user.access_token && Object.keys(this.flavorData).length && this.flavorData?.flavorId && this.flavorData?.flavorId == 38 && this.liveAccounts()){
            this.getQuestioanriesStatus({},false)
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    accountsBecomeLeader(params = {}, loader = false,importHistory) {
      return new Promise((resolve, reject) => {
        if (loader) { this.loading = true; }
        let ep = ENDPOINTS.EP_BECOME_LEADER
        if(importHistory){
          ep = ep.concat('?importHistory=true');
        }
        API.put(ep, params).then((response) => {
          this.loading = false;
          if(Object.keys(response).length){
            toast("Your request for become a leader is submitted successfully.", tostTypeSuccess);
            window.location.replace(`${static_vars.domainURL}dashboard`)
          }
          resolve(response);
        })
        .catch((error) => {
          this.loading = false;
           toast("Some technical issue", tostTypeError);
          reject(error);
        });
      });
    },
    BrokerSignup(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.singleLoading = true
        }
        let ep = ENDPOINTS.EP_BROKER_SIGNUP
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.singleLoading = false
          resolve(response)
        }).catch(error => {
          this.singleLoading = false
          reject(error)
        })
      });
    },
    callUserBrokerStatusList(params = {}, loader = false,ID) {
       return new Promise((resolve, reject) => {
        if (loader) {
          this.singleLoading = true
        }
        let ep = ENDPOINTS.EP_GET_USER_BROKER_STATUS_LIST
        ep = ep.replace("{{ID}}",ID)
        API.get(ep).then(response => {
          this.singleLoading = false
          this.brokerStatusList = response
          resolve(response)
        }).catch(error => {
          this.singleLoading = false
          reject(error)
        })
      })
    },
    callBrokerSettings(params = {}, loader = false,ID) {
       return new Promise((resolve, reject) => {
        if (loader) {
          this.singleLoading = true
        }
        let ep = ENDPOINTS.EP_GET_BROKER_SETTINGS
        ep = ep.replace("{{ID}}",ID)
        API.get(ep).then(response => {
          this.singleLoading = false
          this.brokerSettingsList = response
          resolve(response)
        }).catch(error => {
          this.singleLoading = false
          reject(error)
        })
      })
    },
    saveBrokerPersonalInfo(params = {}, loader = false,ID,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_SAVE_BROKER_PERSONAL_INFO
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          if(response === true){
            router.replace({name : 'create_broker_account3',params:{'id':_that.$route.params.id}})
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    saveBrokerFinancialDetail(params = {}, loader = false,ID,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_SAVE_BROKER_FINANCIAL_DETAIL
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          if(response === true){
            router.replace({name : 'create_broker_account4',params:{'id':_that.$route.params.id}})
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    getBrokerQuestionsList(params = {}, loader = false) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        API.get(ENDPOINTS.EP_GET_BROKER_QUESTIONS_LIST).then(response => {
          this.loading = false
          if(Object.keys(response).length > 0 && response[0].questions && response[0].questions.length){
            response[0].questions = response[0].questions.filter(val => (val.frontend === true && val.status === true))
            this.brokerQuestionsList = response
          }else{
            this.brokerQuestionsList = response
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
           reject(error)
        })
      })
    },
    saveBrokerOuestionaries(params = {}, loader = false,ID,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        const inputjson = JSON.parse(JSON.stringify(params));
        if(params['type']){
          delete params['type']
        }
        let ep = ENDPOINTS.EP_SAVE_BROKER_QUESTIONS
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          if(Object.keys(response).length){
            if(inputjson['type'] && inputjson['type'] == 'suitability'){
              const data = this.userAccoutDetail
              delete data['requiredActions']
              this.userAccoutDetail = data
              if(this.questionariesStatus?.status != 'SUBMITTED'){
                if("2" in response){
                  this.failTest = response['2']
                }else{
                  this.failTest = {}
                  try{
                    // (window as any).teads_e.push({
                    //   conversionType: "CompleteRegistration"
                    // });
                    (window as any).gtag('event', 'Test_Pass');
                    (window as any).fbq('trackCustom', 'Test_Pass', {'email' : this.userAccoutDetail?.email,'value' : '75','country' : this.flavorData?.userCountry?.name }, {'eventID': `${this.userAccoutDetail?.id}_Test_Pass`});
                  }catch(ex){console.log(ex)}
                }
              }
              router.replace({path :'/test-result',query:{'type' : 'success'}});
              // if(!this.linkBrokerID){
              //   window.location.replace(`${static_vars.domainURL}dashboard`)
              // }else{
              //   router.replace('/subscription-plan')
              // }
            }else{
              router.replace({name : 'create_broker_account5',params:{'id':_that.$route.params.id}})
            }
          }
          resolve(response)
        }).catch(error => {
          this.failTest = {}
           if(inputjson['type'] && inputjson['type'] == 'suitability'){
            router.replace({path :'/test-result',query:{'type' : 'failure'}})
          }
          this.loading = false
          reject(error)
        })
      });
    },
    riskWarningStep(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_RISK_WARNING_STEP
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    saveBrokerTerms(params = {}, loader = false,ID,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_SAVE_BROKER_TERMS
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          if(response === true){
            router.replace({name : 'create_broker_account6',params:{'id':_that.$route.params.id}})
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },

    getBrokerStabilityQuestionsList(params = {}, loader = false) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        API.get(ENDPOINTS.EP_GET_BROKER_STABILITY_QUESTIONS_LIST).then(response => {
          this.loading = false
          if(Object.keys(response).length > 0 && response[0].questions && response[0].questions.length){
            response[0].questions = response[0].questions.filter(val => (val.frontend === true && val.status === true))
            this.stabilityQuestionsList = response
          }else{
            this.stabilityQuestionsList = response
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
           reject(error)
        })
      })
    },
    saveBrokerPORDocument(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_SAVE_BROKER_POR_DOCUMENT
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          if(response === true){
            router.replace({name : 'create_broker_account7',params:{'id':ID}})
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    getSumSubToken(params = {}, loader = false,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        API.post(ENDPOINTS.EP_GET_SUM_SUB_TOKEN, params).then(response => {
          this.loading = false
          _that.startSubSub = true
          if(response.token){
            this.sumSubDetail = response
            _that.intializeSumSub(response.token,this.customerDetail.email)
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    saveBrokerSumSubMannualDocument(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_SAVE_BROKER_POR_DOCUMENT
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    openBrokerTicket(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_GET_OPEN_TICKET_TOKEN
        ep = ep.replace("{{ID}}",ID)
        API.get(ep).then(response => {
          this.loading = false
          resolve(response)
        }).catch(error => {
          this.loading = false
           reject(error)
        })
      })
    },
    addBrokerAccountPrefrences(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_SAVE_BROKER_ACCOUNT_PREFRENCES
        ep = ep.replace("{{ID}}",ID)
        API.post(ep, params).then(response => {
          this.loading = false
          if(response === true){
            router.replace({name : 'add_funds',params:{'id':ID}})
          }
          resolve(response)
        }).catch(error => {
          this.loading = false
          reject(error)
        })
      });
    },
    getFundToken(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_GET_BROKER_FUND_TOKEN
        ep = ep.replace("{{ID}}",ID)
        API.get(ep).then(response => {
          this.loading = false
          resolve(response)
        }).catch(error => {
          this.loading = false
           reject(error)
        })
      })
    },
    getBrokerTradingAcc(params = {}, loader = false,ID) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.EP_GET_BROKER_TRADING_ACCOUNTS
        ep = ep.replace("{{ID}}",ID)
        API.get(ep).then(response => {
          this.loading = false
          this.getBrokerTradingAccList = response
          resolve(response)
        }).catch(error => {
          this.loading = false
           reject(error)
        })
      })
    },
    connectExistingBrokerAccount(params = {}, loader = false,id,_that) {
      return new Promise((resolve, reject) => {
        if (loader) {
          this.loading = true
        }
        let ep = ENDPOINTS.CONNECT_INTEGRATED_BROKER_EXISTING_ACCOUNT
        if(id){
          ep = ep.replace('{{ID}}',id)
        }
        API.post(ep, params).then(response => {
          this.loading = false
          // toast("Account Connected Successfully", tostTypeSuccess);
          if(Object.keys(response).length){
            _that.userAccountsList()
          }
           this.linkBrokerStatus = true
           try{
            (window as any).gtag('event', 'Live_ac_verified');
            (window as any).fbq('trackCustom', 'Live_ac_verified', {'email' : this.userAccoutDetail?.email,'value' : '50','country' : this.flavorData?.userCountry?.name }, {'eventID': `${this.userAccoutDetail?.id}_Live_ac_verified`});
          }catch(ex){console.log(ex);}
          resolve(response)
        }).catch(error => {
          this.loading = false
           this.linkBrokerStatus = false
          router.replace('/broker-account')
          toast("Wrong Credentials.Please Check your credentials", tostTypeError);
          reject(error)
        })
      });
    },
    // subscriptionPlansList(params = {}, loader = false) {
    //   if (loader) {
    //     this.loading = true;
    //   }
    //   return new Promise((resolve, reject) => {
    //     API.get(ENDPOINTS.EP_GET_SUBSCRIPTION_PLANS)
    //       .then((response) => {
    //         this.loading = false;
    //         this.subscriptionPlans = response;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.loading = false;
    //         reject(error);
    //       });
    //   });
    // },
    // subscriptionCardList(params = {}, loader = false) {
    //   if (loader) { this.singleLoading = true; }
    //   return new Promise((resolve, reject) => {
    //     API.get(ENDPOINTS.EP_GET_SAVED_CARDS)
    //       .then((response) => {
    //         this.singleLoading = false;
    //         this.subscriptionCards = response;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.singleLoading = false;
    //         reject(error);
    //       });
    //   });
    // },
    // subscriptionPayment(params = {}, loader = false) {
    //   if (loader) {
    //     this.loading = true;
    //   }
    //   return new Promise((resolve, reject) => {
    //     API.post(ENDPOINTS.EP_INITIATE_PAYMENT, params)
    //       .then((response) => {
    //         this.loading = false;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.loading = false;
    //         reject(error);
    //       });
    //   });
    // },
    // subscriptionSelectPlan(params = {}, loader = false) {
    //   if (loader) { this.loading = true; }
    //   return new Promise((resolve, reject) => {
    //     API.post(ENDPOINTS.EP_GET_SELECT_PLAN, params)
    //       .then((response) => {
    //         this.loading = false;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.loading = false;
    //         reject(error);
    //       });
    //   });
    // },
    // getsubscriptionSelectPlan(params = {}, loader = false) {
    //   if (loader) { this.loading = true; }
    //   return new Promise((resolve, reject) => {
    //     API.get(ENDPOINTS.EP_GET_SELECT_PLAN)
    //       .then((response) => {
    //         this.loading = false;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.loading = false;
    //         reject(error);
    //       });
    //   });
    // },
    // subscriptionCancelPlan(params = {}, loader = false) {
    //   if (loader) { this.loading = true; }
    //   return new Promise((resolve, reject) => {
    //     API.DELETE(ENDPOINTS.EP_GET_CANCEL_PLAN)
    //       .then((response) => {
    //         this.loading = false;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.loading = false;
    //         reject(error);
    //       });
    //   });
    // },
    // subscriptionSelectedPlan(params = {}, loader = false) {
    //   if (loader) {
    //     this.loading = true;
    //   }
    //   return new Promise((resolve, reject) => {
    //     API.get(ENDPOINTS.EP_GET_SELECTED_PLAN)
    //       .then((response) => {
    //         this.loading = false;
    //         this.subscriptionSelected = response;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.loading = false;
    //         reject(error);
    //       });
    //   });
    // },
    // subscriptionSavedCheckout(params = {}, loader = false) {
    //   if (loader) { this.loading = true; }
    //   return new Promise((resolve, reject) => {
    //     API.post(ENDPOINTS.EP_GET_SAVED_CUST_CHECKOUT, params)
    //       .then((response) => {
    //         this.loading = false;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.loading = false;
    //         reject(error);
    //       });
    //   });
    // },
    brokerRaiseQuery(params = {}, loader = false) {
      if (loader) { this.loading = true; }
      return new Promise((resolve, reject) => {
        API.post(ENDPOINTS.EP_BROKER_RAISE_QUERY, params)
          .then((response) => {
            this.loading = false;
            toast("Thank you for your submission. We will add your broker shortly", tostTypeSuccess);
            resolve(response);
          })
          .catch((error) => {
            this.loading = false;
            reject(error);
          });
      });
    },
    affilateLanded(params = {}, loader = false) {
      if (loader) { this.loading = true; }
      return new Promise((resolve, reject) => {
        API.post(ENDPOINTS.EP_AFFILATE_LANDED, params)
          .then((response) => {
            this.loading = false;
            resolve(response);
          })
          .catch((error) => {
            this.loading = false;
            reject(error);
          });
      });
    },
    // LOD
    callLOD(params = {}, loader = false,id) {
      if (loader) { this.loading = true }
      let ep = ENDPOINTS.EP_GET_LOD 
      if(id){ ep = ep.replace('{{ID}}',id) }
      return new Promise((resolve, reject) => {
        API.get(ep).then(response => {
          this.loading = false
          const b64 = Buffer.from(response, "binary").toString("base64");
          const respon = `data:application/pdf;base64,${b64}`
          resolve(respon);
        }).catch(error => {
          this.loading = false
          reject(error);
        })
      })
    },
    getQuestioanriesStatus(params = {}, loader = false) {
      if (loader) { this.loading = true; }
      return new Promise((resolve, reject) => {
        let ep = ENDPOINTS.EP_SAVE_BROKER_QUESTIONS
        ep = ep.replace("{{ID}}",'2')
        API.get(ep)
          .then((response) => {
            this.loading = false;
            this.questionariesStatus = response
            resolve(response);
          })
          .catch((error) => {
            this.loading = false;
            reject(error);
          });
      });
    },
    //Reset state vars after OTP verification
    resetOnLoadOrOperationCompletion() {
      this.loading = false
      this.showOTP = false
    },
    clearMessage(){
      this.error = {type : '' ,msg : ''}
    },
    // Get payment type
    getPaymentType(params = {}, loader = false) {
      if (loader) { this.loading = false; }
      return new Promise((resolve, reject) => {
        const ep = ENDPOINTS.GET_PAYMENT_TYPE;
        API.get(ep)
          .then((response) => {
            this.loading = false;
            if(response?.length){
              this.priorityPayment = response.find(i=>i.priority == 1)?.psp || 'CHECKOUT'
            }
            resolve(response);
          })
          .catch((error) => {
            this.loading = false;
            reject(error);
          });
      });
    },
    // Make New Payment
    // unlimitNewPayment(params = {}, loader = false) {
    //   if (loader) { this.singleLoading = true; }
    //   return new Promise((resolve, reject) => {
    //     const ep = ENDPOINTS.UNLIMIT_NEW_PAYMENT;
    //     API.post(ep,params)
    //       .then((response) => {
    //         this.singleLoading = false;
    //         resolve(response);
    //       })
    //       .catch((error) => {
    //         this.singleLoading = false;
    //         reject(error);
    //       });
    //   });
    // },
    //Logout and reset store
    otherBrokersList(params = {}, loader = false) {
      if (loader) { this.loading = true }
      API.get(ENDPOINTS.OTHER_BROKERS_LIST).then(response => {
        this.loading = false
        this.otherBrokerFullList = response
      }).catch(error => {
        this.loading = false
      })
    },
    reset(){
      this.isLogin = true
      this.logout();
    },
    logout() {
      setTimeout(() => {
          //code used to solve problem of autologin when mutiple tabs 
          if(this.isLogin == true){
            const broadcastChannel = new BroadcastChannel('zuluchannel');
            broadcastChannel.postMessage('ExecuteFunction');
            this.isLogin = false;
          }
          this.loading = true;
          if (localStorage.getItem("zulutoken") !== null) {
            localStorage.removeItem("zulutoken");
          }
          if (localStorage.getItem("zulurefreshToken") !== null) {
            localStorage.removeItem("zulurefreshToken");
          }
          if(static_vars.getCookie('zuluUserDetail')){
            static_vars.delete_cookie('zuluUserDetail')
          }
          if(static_vars.getCookie('zuluCountryList')){
            static_vars.delete_cookie('zuluCountryList')
          }
          if (localStorage.getItem("userSetting") !== null) {
            localStorage.removeItem("userSetting");
          }
          const activepinia = getActivePinia();
          if (activepinia) {
            Object.entries(activepinia.state.value).forEach(([storeName, state]) => {
              const storeDefinition = defineStore(storeName, state);
              const store = storeDefinition(activepinia);
              store.$reset();
            });
          }
          location.replace(`${static_vars.domainURL}login`)
          this.loading = false;
      }, 5);
    },


    createDemoAccount(params={},loader = true){
      const _that = this;
        return new Promise((resolve, reject) => {
            if (loader) {
              // this.loading = true;
            }
            let ep = ENDPOINTS.EP_DEMO_ACCOUNT;
            ep = ep.replace("{{customerId}}", _that.customerDetail.customerId);
            API.post(ep,params)
            .then((response) => {
              this.loading = false;
              resolve(response);
            })
            .catch((error) => {
              this.loading = false;
              reject(error);
            });
        });

    },

  },
})